import React from 'react'
import { 
  MdRestaurant, 
  MdLocalFlorist, 
  MdCheckroom,
  MdMiscellaneousServices, 
  MdDirectionsCar,
  MdWeekend,
  MdDoorFront,
  MdConstruction,
  MdElectricalServices,
  MdSpa,
  MdHotel,
  MdFitnessCenter,
  MdPets,
  MdChildCare,
  MdLocalHospital
} from 'react-icons/md'
import styles from './Audience.module.scss'

const audienceItems = [
  { type: 'FOOD', label: 'Рестораны и доставка', icon: MdRestaurant },
  { type: 'FLOWERS', label: 'Цветы', icon: MdLocalFlorist },
  { type: 'CLOTHES', label: 'Одежда и обувь', icon: MdCheckroom },
  { type: 'SERVICES', label: 'Услуги', icon: MdMiscellaneousServices },
  { type: 'AUTO', label: 'Автосалоны', icon: MdDirectionsCar },
  { type: 'FURNITURE', label: 'Магазины мебели', icon: MdWeekend },
  { type: 'DOORS', label: 'Магазины дверей', icon: MdDoorFront },
  { type: 'DIY', label: 'Стройматериалы', icon: MdConstruction },
  { type: 'ELECTRONICS', label: 'Электроника', icon: MdElectricalServices },
  { type: 'COSMETICS', label: 'Косметика и парфюмерия', icon: MdSpa },
  { type: 'HOTEL', label: 'Отели и гостиницы', icon: MdHotel },
  { type: 'SPORT', label: 'Спорттовары', icon: MdFitnessCenter },
  { type: 'PET', label: 'Зоотовары', icon: MdPets },
  { type: 'KIDS', label: 'Детские товары', icon: MdChildCare },
  { type: 'HEALTH', label: 'Медицина и здоровье', icon: MdLocalHospital },
]

export const Audience: React.FC = () => {
  return (
    <div className={styles.grid}>
      {audienceItems.map(({ type, label, icon: Icon }) => (
        <div key={type} className={styles.card}>
          <Icon size={24} />
          <span>{label}</span>
        </div>
      ))}
    </div>
  )
}